import React, { useState } from "react";
import MovimientoInternoForm from "../forms/FormMovimientoInterno";
import MovimientoExternoForm from "../forms/FormMovimientoExterno";

const MovimientoModal = ({ equipoId, clienteId, onClose, onSaved }) => {
  const [tipo, setTipo] = useState("INTERNO");

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50">
      {/* Contenedor modal */}
      <div
        className="
          bg-white w-full sm:max-w-lg
          max-h-[90vh]
          rounded-t-2xl sm:rounded-2xl
          flex flex-col
          overflow-hidden
        "
      >
        {/* Header fijo */}
        <div className="px-4 py-3 border-b flex items-center justify-between">
          <div className="flex gap-2">
            <button
              className={`px-3 py-1 rounded-full text-sm ${
                tipo === "INTERNO"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700"
              }`}
              onClick={() => setTipo("INTERNO")}
            >
              Interno
            </button>
            <button
              className={`px-3 py-1 rounded-full text-sm ${
                tipo === "EXTERNO"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700"
              }`}
              onClick={() => setTipo("EXTERNO")}
            >
              Externo
            </button>
          </div>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-xl"
          >
            ×
          </button>
        </div>

        {/* Contenido con scroll */}
        <div className="flex-1 overflow-y-auto px-4 py-4">
          {tipo === "INTERNO" ? (
            <MovimientoInternoForm
              equipoId={equipoId}
              clienteId={clienteId}
              onClose={onClose}
              onSaved={onSaved}
            />
          ) : (
            <MovimientoExternoForm
              equipoId={equipoId}
              onClose={onClose}
              onSaved={onSaved}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MovimientoModal;
